export const PAGE_VIEWED = "Page Viewed";
export const PAGE_EXITED = "Page Exited";
export const SITE_LEFT = "Site Left";

export const SIGNED_UP = "Signed Up";
export const LOGGED_IN = "Logged In";
export const LOGGED_OUT = "Logged Out";
export const QR_CODE_CREATION_STARTED = "QR Code Creation Started";
export const QR_CODE_CREATED = "QR Code Created";
export const QR_CODE_DOWNLOADED = "QR Code Downloaded";
